<template lang="pug">
.container.plans
  carousel(:class="'plan-wrap'" v-if="items.length && activeCarousel" :height="600" :space="300" :perspective="0" :display="3" :controls-visible="true" :controls-prev-html="'&#10092;'" :controls-next-html="'&#10093;'" )
    slide(v-for="(item, index) in plans" :index="index" :key="index")
      .plan
        .content
          p.title(:style="{color: item.color}")  {{ item.name }}
          .small-line
          .description-wrap(v-html="item.description")
          .small-line
        .price-wrap
          p {{ interpolate(ngettext('%s day', '%s days', item.expiration_time), [item.expiration_time]) }}/{{interpolate(ngettext('%s contact', '%s contacts', item.hits_number), [item.hits_number]) }}
          p.price {{item.price}} {{ gettext('EUR') }}
          button.main-btn.wide.col-white.bg-gray(:style="{'background-color': item.color}" @click="selectPlan(item.id)") {{ gettext('Select plan') }}

  .plan-wrap.plans-default(v-if="items.length && !activeCarousel")
    .plan(v-for="(item, index) in plans" :key="index")
      .content
        p.title(:style="{color: item.color}")  {{ item.name }}
        .small-line
        .description-wrap(v-html="item.description")
        .small-line
      .price-wrap
        p {{ interpolate(ngettext('%s day', '%s days', item.expiration_time), [item.expiration_time]) }}/{{interpolate(ngettext('%s contact', '%s contacts', item.hits_number), [item.hits_number]) }}
        p.price {{item.price}} {{ gettext('EUR') }}
        button.main-btn.wide.col-white.bg-gray(:style="{'background-color': item.color}" @click="selectPlan(item.id)") {{ gettext('Select plan') }}

  v-modal(:show.sync="showAuthModal" :clickAway="true")
    section.modal-card-body
      .is-size-4.has-text-centered.title {{ gettext('Log in your company profile or sign up') }}!
      .btn-wrap(v-if="[CONSTANTS.JOBSEEKER_PROFILE_TYPE, CONSTANTS.SENDER_PROFILE_TYPE].indexOf(getUser.profile_type) === -1")
        router-link.main-btn.col-white.bg-red.nav-item.is-tab(:to="{name: 'Registration', params: {lang: getLanguage}, hash: '#employer'}") {{ gettext('Register') }}
        router-link.main-btn.col-white.bg-black.nav-item.is-tab(:to="{name: 'Login', params: {lang: getLanguage}, query: {redirect: 'account-plan'}}") {{ gettext('Log in') }}
      .btn-wrap(v-else)
        button.main-btn.col-white.bg-red.nav-item.is-tab(@click="logout({name: 'Registration', params: {lang: getLanguage}, hash: '#employer'})") {{ gettext('Register') }}
        button.main-btn.col-white.bg-black.nav-item.is-tab(@click="logout({name: 'Login', params: {lang: getLanguage}, query: {redirect: 'account-plan'}})") {{ gettext('Log in') }}

  v-modal(:show.sync="showSimilarModal" :clickAway="true")
    section.modal-card-body
      .is-size-4.has-text-centered.title {{ gettext('You have already created an invoice. Сontinue working with it?') }}
      .btn-wrap
        router-link.main-btn.col-white.bg-black.nav-item.is-tab(:to="{name: 'Invoice', params: {lang: getLanguage}, query: {id: similar}}") {{ gettext('Continue') }}
        button.main-btn.col-white.bg-red.nav-item.is-tab(@click="cancelInv") {{ gettext('Cancel invoice') }}

  v-modal(:show.sync="showConfirmModal" :clickAway="true")
    section.modal-card-body.invoice-confirm-modal
      .is-size-4.has-text-centered.title {{ gettext('You have already an active plan. Do you want to change it?') }}
      .card
        .card-content
          p.has-text-centered {{gettext('You current plan:')}}
          table.table.is-fullwidth
            thead
              tr
                th {{gettext('Hits')}}
                th {{gettext('Expire')}}
            tbody
              tr
                td {{`${confirmModalContent.left_hits_number}/${confirmModalContent.max_hits_number} (${interpolate(gettext('Used %s'), [confirmModalContent.used_hits_number])})`}}
                td {{confirmModalContent.expire | date}}
      .btn-wrap
        button.main-btn.col-white.bg-red.nav-item.is-tab(@click="buy(service, getFinanceAccount)") {{ gettext('Change plan') }}
        button.main-btn.col-white.bg-black.nav-item.is-tab(@click="showConfirmModal = false") {{ gettext('Close') }}

</template>
<script>
import { Carousel3d, Slide } from 'vue-carousel-3d'
import { gettext, ngettext, interpolate } from '@/services/TranslateHandler'
import { mapGetters, mapActions } from 'vuex'
import VModal from '@/components/modal'
const CONSTANTS = require('@/constants.json')
const moment = require('moment')

const _ = require('lodash')

export default {
  name: 'Plans',
  components: {
    'carousel': Carousel3d,
    Slide,
    VModal
  },
  data () {
    return {
      CONSTANTS: CONSTANTS,
      showAuthModal: false,
      showSimilarModal: false,
      activeCarousel: false,
      showConfirmModal: false,
      confirmModalContent: {},
      service: '',
      similar: ''
    }
  },
  props: {
    items: {
      default: () => []
    }
  },
  filters: {
    date: function (val) {
      return moment(val).format('DD/MM/YYYY')
    }
  },
  methods: {
    ...mapActions([
      'getBillingProvidedServices',
      'logout',
      'createInvoice',
      'cancelInvoice'
    ]),
    gettext: gettext,
    ngettext: ngettext,
    interpolate: interpolate,
    selectPlan (service) {
      if (!this.$auth.check() || [CONSTANTS.RECEIVER_PROFILE_TYPE, CONSTANTS.EMPLOYER_PROFILE_TYPE].indexOf(this.getUser.profile_type) === -1) {
        this.showAuthModal = true
      } else {
        this.getActivePackage(service)
      }
    },
    getActivePackage (service) {
      this.getBillingProvidedServices({lang: this.getLanguage, account: this.getFinanceAccount, archive: false, pageNum: 1, pageSize: 50}).then(res => {
        if (res.length) {
          _.each(res, item => {
            if (item.type === CONSTANTS.CV_PROVIDED_SERVICE_NAME) {
              this.showConfirmModal = true
              this.confirmModalContent = item
              this.service = service
            } else {
              this.buy(service, this.getFinanceAccount)
            }
          })
        } else {
          this.buy(service, this.getFinanceAccount)
        }
      })
    },
    buy (service, account) {
      this.service = service
      this.showConfirmModal = false
      this.createInvoice({lang: this.getLanguage, account: account, service: service, type: CONSTANTS.CV_PACKAGE_TYPE_NAME}).then(res => {
        if (res.success) {
          this.$router.push({name: 'Invoice', params: {lang: this.getLanguage}, query: {id: res.invoice_id}})
        } else if (res.similar_exists) {
          this.showSimilarModal = true
          this.similar = res.similar_invoice_id
        }
      })
    },
    async cancelInv () {
      this.showSimilarModal = false
      await this.cancelInvoice({lang: this.getLanguage, invoice: this.similar})
      this.buy(this.service, this.getFinanceAccount)
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage',
      'getUser',
      'getFinanceAccount'
    ]),
    plans: function () {
      return _.sortBy(this.items, 'weight')
    }
  }
}
</script>
<style lang="scss">
.carousel-3d-container {
  .carousel-3d-slide {
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/choose-account-plan/parts/plans/index.vue